<template lang="">
  <div class="message-form" style="height: 110vh">
    <Header
      title="Disparos de SMS ou Push App"
      subtitle="Área voltada para o envio de SMS"
      :has-separator="false"
    ></Header>

    <!-- Canal de envio -->
    <ValidationObserver v-slot="{ invalid }">
      <div class="d-flex responvive-short-card">
        <div>
          <!-- Formulario -->
          <v-card class="pa-8 mb-12" height="538" width="826">
            <div class="d-flex flex-column">
              <span class="font-weight-black" for="name"> Nome </span>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <input
                  class="input-field pl-2 mt-3"
                  placeholder="Nome da campanha"
                  v-model="infos.name"
                  name="nome da campanha"
                />
                <span class="input-error">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
              <span class="font-weight-black mt-4" for="name"> Título </span>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <input
                  class="input-field pl-2 mt-3"
                  placeholder="Empiricus"
                  v-model="infos.title"
                  name="título"
                />
                <span class="input-error">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
              <span class="font-weight-black mt-4">
                Mensagem
                <span class="textAreaLength">{{ textAreaLength }} / 127</span>
              </span>
              <textarea
                outlined
                rows="10"
                maxlength="127"
                max-height="200"
                class="text-area-field mt-3"
                style="max-height: 200px"
                placeholder="Mensagem"
                row-height
                v-model="infos.message"
              ></textarea>
            </div>
          </v-card>

          <!-- Informações adicionais -->
          <h4 class="mb-5">Informações Adicionais da Mensagem</h4>
          <v-card class="pa-8 mb-12" width="826" height="609">
            <div class="format-url pa-6">
              <div>
                <p>Url</p>

                <template v-if="isDeeplink && deeplink">
                  <input
                    disabled
                    class="input-format-url pl-2 mr-2"
                    style="cursor: not-allowed"
                    v-model.trim="deeplink"
                  />
                </template>

                <template v-else>
                  <input
                    placeholder="Url"
                    class="input-format-url pl-2 mr-2"
                    v-model.trim="infos.url"
                    @blur="convertToDeeplink"
                  />
                </template>

                <span
                  class="input-error"
                  style="font-weight: bold"
                  v-if="!isValidUrl"
                >
                  URL inválida
                </span>
              </div>

              <div class="d-flex flex-row align-center">
                <v-switch
                  inset
                  v-model="isDeeplink"
                  @change="convertToDeeplink"
                />

                <span>Converter para deeplink</span>
              </div>
            </div>

            <div class="mt-3 d-flex align-center">
              <img src="../../../../static/images/warning.svg" />
              <label class="ml-4 mt-1"
                >Utilizar esse campo em mensagens SMS pode quebrar o link em
                duas mensagens e o link acabar invalidado.</label
              >
            </div>

            <div class="d-flex flex-column">
              <span class="font-weight-black mt-5"> Listas </span>
              <div class="text-area-field">
                <select
                  v-if="hasLists"
                  v-model="group"
                  multiple
                  style="width: 758px; height: 100%"
                >
                  <option
                    v-for="(com, index) in lists"
                    :key="index"
                    class="pa-2"
                  >
                    {{ com.text }}
                  </option>
                </select>
                <select v-else multiple style="width: 758px; height: 100%">
                  <option class="pa-2">Sem listas disponíveis</option>
                </select>
              </div>
            </div>
          </v-card>
        </div>

        <!-- Coluna 2 - Area de testes -->
        <div class="responvive-card">
          <!-- Area de teste -->
          <div class="calendar-card mr-6">
            <v-card class="px-8 py-8 schedule-teste">
              <h4>Área de testes</h4>
              <p class="mt-1">
                Antes de disparar os SMS faça o teste com o seu smartphone
              </p>

              <p class="font-weight-black mt-9" style="fontsize: 14px">
                Visualização (sem acentuação para SMS)
              </p>
              <textarea
                placeholder="Empiricus"
                outlined
                rows="10"
                maxlength="127"
                class="text-area-field test-area mt-2 px-2 py-2"
                disabled
                style="cursor: not-allowed"
              >
              </textarea>
              <v-btn
                disabled
                width="308"
                height="56"
                color="var(--red)"
                class="mt-7"
              >
                Enviar Teste por SMS
                <img
                  class="ml-5"
                  src="../../../../static/images/send_grey.svg"
                />
              </v-btn>
            </v-card>
          </div>

          <!-- Agendamento -->
          <div class="calendar-card" style="margintop: 92px">
            <v-card class="px-8 py-8 schedule-card">
              <h4>Agendamento</h4>
              <p class="mt-1">Escolha data e hora para que o envio do SMS</p>
              <v-card class="mt-11 d-flex flex-column" width="290">
                <v-date-picker
                  v-model="infos.date"
                  locale="pt-Br"
                  :hide-header="false"
                  no-title
                  :min="currentDate"
                ></v-date-picker>
                <!-- :allowed-dates="day" -->
                <span
                  class="rounded ma-3 d-flex align-center justify-flex-start"
                  style="border: 2px solid var(--grey-day-030); height: 48px"
                >
                  <img
                    class="ma-3"
                    src="../../../../static/images/calendar.svg"
                  />{{ formatDate(infos.date) }}
                </span>
                <div
                  class="d-flex align-center justify-space-around ml-7"
                  style="width: 220px"
                >
                  <v-row height="56" class="mt-5">
                    <span class="pt-5 font-weight-black mr-4">Horário</span>
                    <v-text-field
                      height="58"
                      width="100"
                      solo
                      type="time"
                      v-model="infos.hour"
                      name="horário"
                    ></v-text-field>
                  </v-row>
                </div>
              </v-card>
            </v-card>
          </div>
        </div>
      </div>

      <!-- Card enviar -->
      <v-card
        class="d-flex flex-row mt-8 justify-space-between align-center pa-7 mb-8 responsive-send-card"
        height="72px"
        color="var(--grey-day-070"
      >
        <span class="white--text"
          >Este disparo estará disponível dentro de Agendamentos. Se necessário
          poderá ser alterado ou cancelado.</span
        >
        <v-btn
          height="48"
          width="220"
          class="px-3 py-3"
          :disabled="invalid"
          @click="sendNewMessage"
        >
          <clip-loader
            v-if="loading"
            :loading="loading"
            color="var(--black)"
            size="22px"
          />
          <img v-if="!loading" src="../../../../static/images/save.svg" />
          <span
            class="pl-3 py-3 sendMessage"
            style="fontfamily: var(--dm-sans-regular)"
            >Enviar mensagem</span
          >
        </v-btn>
      </v-card>
    </ValidationObserver>

    <div style="height: 01px"></div>
  </div>
</template>
<script>
// Components
import Header from '@/components/Header.vue';

// Libs
import { mapActions, mapState, mapMutations } from 'vuex';
import moment from 'moment';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { removeSpecialCharacters } from '@/helpers/string.js';

//mixins
import date from '../../../mixins/date';

import VueCookies from 'vue-cookies';

export default {
  components: {
    Header,
    ValidationProvider,
    ValidationObserver,
    ClipLoader,
  },
  mixins: [date],
  data() {
    return {
      channel: '',
      group: [],
      row: null,
      currentDate: moment().format('YYYY-MM-DD'),
      groupIds: '',
      errorMessage: '',
      openError: false,
      timeout: 3000,
      infos: {
        messageChannel: 'PUSH_MOE',
        groupIds: null,
        message: '',
        messageType: 'SIMPLE',
        nameCampaign: '',
        name: '',
        pushType: '',
        smsMessage: this.smsContent,
        title: '',
        url: '',
        date: moment().format('YYYY-MM-DD'),
        hour: '00:00',
      },
      filterText: '',
      selectedOptions: this.selected,
      loading: false,
      isDeeplink: true,
      deeplinkProtocol: 'empiricusresearchapp:',
      deeplink: '',
    };
  },
  async created() {
    window.scrollTo(0, 0);
    this.addScript();
    await this.fecthGroups();
  },
  computed: {
    ...mapState('Logs', {
      item: 'logsToEdit',
    }),
    ...mapState('MessageForm', {
      list: 'list',
    }),
    textAreaLength() {
      return (this.infos && this.infos.message ? this.infos.message : '').length;
    },
    hasLists() {
      return Array.isArray(this.list) && this.list.length > 0;
    },
    lists() {
      return (Array.isArray(this.list) ? this.list : []).map((l) => ({
        text: l.group_name,
      }));
    },
    isValidUrl() {
      return !this.infos.url || this.validateUrl(this.infos.url);
    },
    linkNotConverted() {
      return (
        this.isDeeplink &&
        !this.validateUrl(this.deeplink, [this.deeplinkProtocol])
      );
    },
  },
  methods: {
    onToggle(option) {
      if (option.selected) {
        this.selectedOptions.push(option.value);
      } else {
        this.selectedOptions.splice(
          this.selectedOptions.indexOf(option.value),
          1
        );
      }
    },
    clear() {
      this.selectedOptions = [];
    },
    ...mapActions('MessageForm', {
      groups: 'groups',
      postLogs: 'postLogs',
    }),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER',
    }),
    async fecthGroups() {
      const token = VueCookies.get('jwt-login');

      if (!token) {
        this.toaster('Sessão expirada. Faça login novamente.', 'warning', true);
        return;
      }

      try {
        const response = await this.groups(token);

        if (!response || response.status >= 400) {
          this.toaster('Ocorreu um erro ao buscar grupos', 'warning', true);
        }
      } catch (error) {
        this.toaster('Ocorreu um erro ao buscar grupos', 'warning', true);
      }
    },
    async sendNewMessage() {
      if (this.linkNotConverted) await this.convertToDeeplink();

      if (!this.isValidUrl) {
        return this.toaster('URL inválida', 'danger', true);
      }

      const setTime = `${this.infos.date} ${this.infos.hour}:00-0300`;

      var date = new Date();

      this.infos.nameCampaign = `${this.infos.name} - ${Math.round(
        new Date(
          date.getTime() + -1 * date.getTimezoneOffset() * 60000
        ).getTime() / 1000
      )}`;
      const token = VueCookies.get('jwt-login');
      let payload = {
        messageChannel: this.infos.messageChannel,
        groupIds: this.group,
        message: this.infos.message,
        messageType: this.infos.messageType,
        nameCampaign: removeSpecialCharacters(this.infos.nameCampaign),
        name: removeSpecialCharacters(this.infos.name),
        smsMessage: removeSpecialCharacters(this.infos.message),
        title: this.infos.title,
        url: this.isDeeplink ? this.deeplink : this.infos.url,
      };

      if (moment().isBefore(moment(setTime))) {
        payload = {
          sendTime: setTime,
          ...payload,
        };
      }
      try {
        this.loading = true;
        const response = await this.postLogs([payload, token]);
        this.loading = false;
        if (response.status >= 400) {
          this.toaster(response.data.message, 'red', true);
          return;
        } else {
          this.toaster('Agendamento criado com sucesso', 'green', true);
          this.$router.push({
            name: 'SchedulingWeb',
          });
          this.clearForm();
        }
      } catch (error) {
        this.toaster(error.message, 'danger', true);
        return;
      }
    },
    clearForm() {
      this.infos = {
        messageChannel: 'PUSH_MOE',
        groupIds: null,
        message: '',
        messageType: 'SIMPLE',
        nameCampaign: '',
        name: '',
        pushType: '',
        smsMessage: this.smsContent,
        title: '',
        url: '',
        hour: '00:00',
        date: moment().format('YYYY-MM-DD'),
      };
    },
    extractAllQueryParams(originalUrl) {
      var url = originalUrl;
      var result = [];

      while (url.indexOf('?') !== -1 && url.indexOf('?') + 1 < url.length) {
        var queryStartIndexOf = url.indexOf('?');
        var queryEndIndexOf =
          url.indexOf('#') > queryStartIndexOf ? url.indexOf('#') : url.length;

        var queryStrFragment = url.substring(
          queryStartIndexOf + 1,
          queryEndIndexOf
        );
        url =
          queryEndIndexOf < url.length ? url.substring(queryEndIndexOf) : '';

        var parts = queryStrFragment.split('&');

        for (var i = 0; i < parts.length; i++) {
          var part = parts[i];

          if (part !== '') {
            result.push(part);
          }
        }
      }

      return result;
    },
    extractFragment(originalUrl) {
      var result = null;

      var startIndexOf = originalUrl.indexOf('#');
      var endIndexOf = originalUrl.lastIndexOf('?');

      if (endIndexOf === -1) {
        endIndexOf = originalUrl.length;
      }

      if (startIndexOf !== -1 && endIndexOf - startIndexOf >= 2) {
        result = originalUrl.substring(startIndexOf + 1, endIndexOf);
      }

      return result;
    },
    extractDomainWithPath(originalUrl) {
      var fragmentIndexOf = originalUrl.indexOf('#');
      var queryIndexOf = originalUrl.indexOf('?');
      var limitIndexOf = originalUrl.length;

      if (queryIndexOf > -1 && queryIndexOf < limitIndexOf) {
        limitIndexOf = queryIndexOf;
      }
      if (fragmentIndexOf > -1 && fragmentIndexOf < limitIndexOf) {
        limitIndexOf = fragmentIndexOf;
      }

      return originalUrl.substring(0, limitIndexOf);
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible,
      });
    },
    addScript() {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src =
        'https://empiricus-app.empiricus.com.br/v2/assets/js/deeplinkconverter.js';
      head.appendChild(script);
    },
    validateUrl(str, protocols = ['http:', 'https:']) {
      let url;

      try {
        url = new URL(str);
      } catch (error) {
        return false;
      }

      return protocols.includes(url.protocol);
    },
    removeFirstPathSegmentIfNeeded(originalUrl) {
      const segmentsToRemove = ['seudinheiro', 'empiricus', 'marketmakers', 'optme', 'btg'];

      let parsedUrl;

      try {
        parsedUrl = new URL(originalUrl);
      } catch (error) {
        return originalUrl;
      }

      const pathSegments = parsedUrl.pathname
        .split('/')
        .filter((segment) => segment.length);

      const [firstSegment] = pathSegments;

      if (!firstSegment || !segmentsToRemove.includes(firstSegment)) return originalUrl;

      const remainingSegments = pathSegments.slice(1);

      parsedUrl.pathname = remainingSegments.length
        ? `/${remainingSegments.join('/')}`
        : '/';

      return parsedUrl.toString();
    },
    convertToDeeplink() {
      if (!this.infos.url) return;

      const { parseUrl } = window.DeeplinkConverter;

      const shouldConvert = this.isDeeplink && this.isValidUrl;

      if (!shouldConvert) {
        this.deeplink = '';
        return;
      }

      const isConvertedDeeplink = (value) =>
        !!(value && String(value).startsWith('empiricusresearchapp://'));

      let parsed = parseUrl(this.infos.url);

      if (!isConvertedDeeplink(parsed)) {
        const sanitizedUrl = this.removeFirstPathSegmentIfNeeded(this.infos.url);
        if (sanitizedUrl !== this.infos.url) {
          const parsedSanitized = parseUrl(sanitizedUrl);
          if (isConvertedDeeplink(parsedSanitized)) {
            parsed = parsedSanitized;
          }
        }
      }

      this.deeplink = parsed;
    },
  },
};
</script>
<style lang="" scoped>
.select-list-wrapper {
  padding: 10px;
}

.input-error {
  font-size: 12px;
  color: var(--red);
}

.select-list-actions {
  padding: 0;
  margin-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: flex-end;
}
.button.is-link {
  color: #7a7a7a;
  text-decoration: none;
}
.select-list {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.select-item {
  flex-basis: 20%;
  margin-bottom: 1%;
  justify-content: flex-start;
}

.toggle-button {
  background: none;
  color: #7a7a7a;
  border: none;
  padding-left: 25px;
  position: relative;
  margin-left: 0 !important;
  transition: font-weight 0.1s ease-in;
}

.toggle-button:focus {
  box-shadow: none;
}

.is-selected {
  color: #00d1b2;
}

h4 {
  font-size: 20px;
}

span {
  line-height: 21.33px;
}

p {
  font-size: 14px;
}

label {
  font-size: 12.64px;
  font-weight: 500;
}

td,
headerTable {
  height: 20px !important;
}

.input-field {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  height: 48px;
  width: 100%;
}

.input-format-url {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  height: 48px;
  width: 100%;
  background: var(--white);
}

.text-area-field {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
  height: 192px;
}

.test-area {
  background: var(--grey-day-010);
  width: 308px;
}

.textAreaLength {
  font-size: 14.22px;
  color: var(--grey);
  font-weight: 100;
}

.format-url {
  background: var(--grey-day-060);
  border-radius: 4px;
  color: var(--white);
  width: 762px;
}

.sizeBtn,
.sendMessage {
  font-size: 12px;
  text-transform: capitalize;
}
.sendMessage {
  font-size: 14px;
  text-transform: capitalize;
}

/* tirando a borda do campo de */
.vs__dropdown-toggle {
  border: none !important;
}

.v-picker__title {
  display: none !important;
}

.responvive-short-card {
  flex-direction: row;
}

.calendar-card {
  margin-left: 24px;
}

.schedule-card {
  height: 579;
  width: 372px;
}
.schedule-teste {
  height: 535px;
  width: 372px;
}

@media screen and (max-width: 1377px) {
  .responsive-send-card {
    width: 819px;
  }
  .schedule-card {
    height: 665px;
    width: 400px;
  }
  .schedule-teste {
    height: 665px;
    width: 400px;
  }
  .responvive-short-card {
    display: flex;
    flex-direction: column;
  }
  .responvive-card {
    display: flex;
    flex-direction: row;
  }
  .calendar-card {
    margin-top: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contents/Message/MessageForm.vue